import { GA4_MEASUREMENT_ID } from './Constants'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

let gtagLoaded = false

// Loads gtag on first use and only when a measurement ID is configured, so
// environments without GA4_MEASUREMENT_ID ship no analytics at all.
const ensureGtag = (): boolean => {
  if (!GA4_MEASUREMENT_ID) {
    return false
  }

  if (gtagLoaded) {
    return true
  }

  window.dataLayer = window.dataLayer ?? []
  window.gtag = function gtag () {
    window.dataLayer?.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', GA4_MEASUREMENT_ID, { send_page_view: false })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA4_MEASUREMENT_ID)}`
  document.head.appendChild(script)

  gtagLoaded = true
  return true
}

// Emits the standard GA4 sign_up event. Event parameters must never include
// email addresses, names, or any other personal data.
export const trackSignUp = (method: 'email' | 'google'): void => {
  try {
    if (ensureGtag()) {
      window.gtag?.('event', 'sign_up', { method })
    }
  } catch {
    // Analytics must never interfere with the signup flow.
  }
}
